// extracted by mini-css-extract-plugin
export default {"navbarLang":"style_navbarLang__E1xo4","lang":"style_lang__rEOzd","en":"style_en__XCB5B","ru":"style_ru__ZJ+Mb","kk":"style_kk__4yZh3","cn":"style_cn__HDs6E"};